import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { KeyValues10, KeyValues20, LocalService, PricingManagementWrapper, SummaryType } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-summary-details',
  templateUrl: './summary-details.component.html',
  styleUrl: './summary-details.component.scss'
})
export class SummaryDetailsComponent {
  @ViewChild('content_summary_details')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["summary", "local_locations"];

  @Input() id: string; @Input() summaryType: SummaryType = SummaryType.None; @Input() ctryCode: string = '';
  item: KeyValues20; isLoadPayaments = false; isLoadWorkingHours = false;
  contentItem = ''; contentLanguageId = ''; pricingDetails: PricingManagementWrapper[];
  workingHours: KeyValues10; isShowProductBarCode = false; isShowProductPricing = false;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService, private router: Router, private productManagementService: ProductManagementService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onInitiate();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    switch (this.summaryType) {
      case SummaryType.Guide: {
        this.configurationManagementService.getGuideContent(1, parseInt(this.id)).subscribe(result => {
          this.contentItem = result.value;
          this.contentLanguageId = result.key;
        });
      } break;
      default: {
        this.configurationManagementService.getSummary(this.id, this.summaryType, this.ctryCode).subscribe(result => {
          this.item = result;
        });
      } break;
    }
  }

  onInitiate() {
    switch (this.summaryType) {
      case SummaryType.User:
      case SummaryType.ServiceProvider: {
        this.lstSectionConfigKeys.push('create_account');
      } break;
      case SummaryType.Business: {
        this.lstSectionConfigKeys.push('seller');
      } break;
      case SummaryType.Guide: {
        this.lstSectionConfigKeys.push('guide');
      } break;
      case SummaryType.Product: {
        this.lstSectionConfigKeys.push('product_config');
      } break;
    }
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  onAction(index, type = null) {
    switch (index) {
      case 1: {
        this.isLoadPayaments = true;
      } break;
      case 2: {
        this.isLoadWorkingHours = true;
        this.sellerManagementService.getWorkingRange(this.id, type).subscribe(result => {
          this.workingHours = result;
        });
      } break;
      case 3: {
        this.router.navigate(['/guide/1', this.id]);
        this.onCloseTrigger();
      } break;
      case 4: {
        this.isShowProductBarCode = true;
      } break;
      case 5: {
        this.isShowProductPricing = true;
        this.productManagementService.getPricingManagment(type, this.id, '').subscribe(result => {
          this.pricingDetails = result.pricings;
        });
      } break;
    }
  }

  getLanguageCodeName(name: string, isCode: boolean) {
    let names = name.split('&split');
    return isCode ? names[0] : names[1];
  }

}
